<template>
  <div @click="initAudio">
    <div class="container">
      <!-- 画布区域 -->
      <div 
        class="canvas"
        ref="canvas"
        @touchstart="handleCanvasTouchStart"
        @touchmove="handleCanvasTouchMove"
        @touchend="handleCanvasTouchEnd"
        @mousedown="handleCanvasMouseDown"
        @mousemove="handleMouseMove"
        @mouseup="handleMouseUp"
        @mouseleave="handleMouseLeave"
      >
        <div 
          v-for="(img, index) in imagesData" 
          :key="index + 'imagesData'"
          class="image-container"
          :data-id="img.id"
          :style="{
            left: `${img.x}px`,
            top: `${img.y}px`,
            width: `${img.width}px`,
            height: `${img.height}px`,
            zIndex: img.zIndex,
            border: selectedImageId === img.id ? '2px solid #2196F3' : 'none',
            filter: img.filter,
          }"
          @mousedown="(e) => handleImageMouseDown(img, e)"
        >
          <!-- 新增删除按钮 -->
          <div 
            v-if="selectedImageId == img.id && img.type != 1"
            class="delete-button"
            @click.stop="removeImageById(img.id)"
          >
            ×
          </div>
          <img 
            :src="imgHttps + img.url" 
            :alt="`Image ${index + 1}`"
            class="image"
            style="object-fit: contain;"
          />
          
          <!-- 缩放控制点 -->
          <div 
            v-if="selectedImageId === img.id"
            class="resize-handle"
            @mousedown="(e) => handleResizeMouseDown(img, e)"
          ></div>
        </div>
      </div>
      
      <!-- 控制区域 -->
      <!-- <div class="control-panel">
        <div class="toolbar">
          
          <div class="layer-controls" v-if="selectedImage">
            <button 
              @click="changeLayer('top')"
              :disabled="selectedImage.zIndex === maxZIndex"
              class="layer-btn"
            >
              <i class="icon-top"></i> 置顶
            </button>
            <button 
              @click="changeLayer('up')"
              :disabled="selectedImage.zIndex === maxZIndex"
              class="layer-btn"
            >
              <i class="icon-up"></i> 上移
            </button>
            <button 
              @click="changeLayer('down')"
              :disabled="selectedImage.zIndex === 1"
              class="layer-btn"
            >
              <i class="icon-down"></i> 下移
            </button>
            <button 
              @click="changeLayer('bottom')"
              :disabled="selectedImage.zIndex === 1"
              class="layer-btn"
            >
              <i class="icon-bottom"></i> 置底
            </button>
          </div>
        </div>
      </div> -->
    </div>
    <van-dialog
      v-model="nameTip"
      title="作品名称"
      @confirm="save"
      :close-on-click-overlay="true"
    >
      <van-field v-model="name" label="" placeholder="请填写作品名称" />
    </van-dialog>
    <van-dialog
      v-model="sucessTip"
      title=""
      @confirm="back"
      :close-on-click-overlay="true"
      :show-confirm-button="false"
    >
      
      <div class="suc-main">
        <div>已保存至，我的_ <span>[我的作品]</span></div>
        <!-- <div>效果图已下载至相册</div> -->
      </div>
    </van-dialog>
    <audio ref="audio" :src="musicUrl" loop></audio>
  </div>
</template>

<script>
import { Editor } from "../../../../3D-editor/index";
import { base64ToFile, uploadImage } from "@/plugins/utils.js";
import { Toast } from "vant";
import wx from "weixin-js-sdk";
let editor;
export default {
  data() {
    return {
      nameTip: false,
      name: '',
      sucessTip: false,
      musicUrl: '',
      hasMusic: true,
      imgHttps: 'https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/',

      musicData: {},
      bgData: {},
      imagesData: [],
      nextImageId: 1,
      maxZIndex: 1,
      selectedImageId: null,
      
      // 拖动相关状态
      isDragging: false,
      isResizing: false,
      dragStartX: 0,
      dragStartY: 0,
      imageStartX: 0,
      imageStartY: 0,
      imageStartWidth: 0,
      imageStartHeight: 0,
      brightness: 100,
      contrast: 100,
      saturation: 100,
      hasInteracted: false
    };
  },
  computed: {
    selectedImage() {
      return this.imagesData.find(img => img.id === this.selectedImageId);
    }
  },
  watch: {
    sucessTip(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        // this.back();
      }
    }
  },
  mounted() {
    this.addBusEvent()
    console.log(this.$store.state.routeParams.productId, this.$route.query.productExpandId)
    if (
      this.$store.state.routeParams.productId ||
      this.$route.query.productExpandId
    ) {
      this.id = this.$store.state.routeParams.productId || "";
      this.getData(this.id);
    }
  },
  methods: {
    getData(id) {
      let url = "/product/getById";
      let params = {
        id,
        type: 1,
      };
      if (this.$route.query.productExpandId) {
        url = "/product/expand/getById";
        params = {
          productExpandId: this.$route.query.productExpandId,
          type: 1,
        };
      }

      this.$ajax
        .get(url, {
          params,
        })
        .then((res) => {
          // this.name = this.$route.query.productExpandId ? "" : res.data.name;
          this.name = res.data.name;

          this.describe = res.data.describe;

          let dataJsonHrss = JSON.parse(res.data.dataJsonHrss) || {}
          this.musicData = dataJsonHrss.musicData || {}
          this.bgData = dataJsonHrss.bgData || {}

          this.brightness = dataJsonHrss.brightness || 100
          this.contrast = dataJsonHrss.contrast || 100
          this.saturation = dataJsonHrss.saturation || 100
          this.$bus.$emit('color-init', {
            id: id,
            brightness: this.brightness,
            contrast: this.contrast,
            saturation: this.saturation,
          });
          
          if (this.musicData.audioUrl) {
            this.musicUrl = this.imgHttps + this.musicData.audioUrl
            this.$bus.$emit('addMusic', this.musicUrl);
            setTimeout(() => {
              this.toggleMusic(true)
              
            }, 500);
          }
          if (this.bgData.thumbnailImage) {
            const canvas = this.$refs.canvas;
            canvas.style.backgroundImage = `url(${this.imgHttps + this.bgData.thumbnailImage})`
          }
          console.log(this.imagesData.length, 'this.imagesData.length')
          if (dataJsonHrss.imagesData && dataJsonHrss.imagesData.length > 0) {
            dataJsonHrss.imagesData.forEach((item, index) => {
              if (item.url) {
                this.addImage(item.url, item.type, item)
              }
            })
          } else {
            this.addImage(res.data.coverImage, 1);
          }
          if (this.brightness != 100 || this.contrast != 100 || this.saturation != 100) {
            this.updateImageEffects()
          }
        });
    },
    addBusEvent() {
      // 替换音乐
      this.$bus.$on("changeMusic", (params) => {
        console.log(params  , 'changeMusic')
        if (params) {
          this.musicData = params.data
          this.musicUrl = params.url
          this.$bus.$emit('addMusic', this.musicUrl);
          this.toggleMusic()
        }
      });
      // 控制音乐 
      this.$bus.$on("changeMusicFlag", (params) => {
        console.log(params  , 'changeMusicFlag')
        if (params) {
          this.toggleMusic(params.flag)
        }
      });
      // 替换茶几
      this.$bus.$on("changeTable", (params) => {
        console.log(params  , 'changeTable')
        if (params) {
          this.addImage(params.url, 2)
        }
      });
      // 替换背景
      this.$bus.$on("changeBg", (params) => {
        console.log(params  , 'changeBg')
        if (params) {
          this.bgData = params.data
          const canvas = this.$refs.canvas;
          canvas.style.backgroundImage = `url(${params.url})`
        }
      });
      // 图层调整
      this.$bus.$on("setCoverage", (params) => {
        console.log(params  , 'setCoverage')
        if (params) {
          this.changeLayer(params)
        }
      });
      this.$bus.$on("setBrightness", (params) => {
        console.log(params  , 'setBrightness')
        if (params) {
          this.brightness = params;
          this.updateImageEffects()
        }
      });
      this.$bus.$on("setContrast", (params) => {
        console.log(params  , 'setContrast')
        if (params) {
          this.contrast = params;
          this.updateImageEffects()
        }
      });
      this.$bus.$on("setSaturation", (params) => {
        console.log(params  , 'setSaturation')
        if (params) {
          this.saturation = params;
          this.updateImageEffects()
        }
      });
      //保存
      this.$bus.$on("saveHrss", (type, form) => {
        if (type === "practice") {
          this.save();
        } else {
          this.workSave(form);
        }
      });
    },
    toggleMusic(flag) {
      console.log('toggleMusic', flag)
      if (flag != null) this.hasMusic = flag
      const audio = this.$refs.audio;
      if (this.hasMusic) {
        audio.oncanplay = () => {
          audio.play().catch(error => {
            console.error('播放音乐失败:', error);
          });
        };
        audio.play().catch(error => {
            console.error('播放音乐失败:', error);
          });
      } else {
        audio.pause();
      }
    },
    getOSSKey() {
      return new Promise((resolve) => {
        this.$ajax
          .post("/user/oss/getKey?pathName=common")
          .then(async (res) => {
            this.ossData = res.data;
            resolve(res.data);
          });
      });
    },
    async save() {
      this.nameTip = false;
      if (
        this.imagesData.length < 1
      ) {
        Toast("请先编辑后再保存");
        return;
      }
      console.log(this.id, this.name, 'this.name')
      if (!this.id || !this.name) {
        Toast("请输入作品名称");
        this.nameTip = true;
        return;
      }

      if (!this.$refs.canvas) {
        console.error('未获取到 canvas 元素');
        return;
      }

      const canvas = this.$refs.canvas;
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');

      const scale = 2;
      const originalWidth = canvas.offsetWidth;
      const originalHeight = canvas.offsetHeight;

      tempCanvas.width = originalWidth * scale;
      tempCanvas.height = originalHeight * scale;
      
      // 绘制背景图片（不应用任何滤镜）
      const computedStyle = getComputedStyle(canvas);
      const backgroundImage = computedStyle.backgroundImage;
      if (backgroundImage && backgroundImage !== 'none' && backgroundImage.startsWith('url')) {
        const imgUrl = backgroundImage.slice(4, -1).replace(/"/g, '');
        const img = new Image();
        img.crossOrigin = 'anonymous';
        await new Promise((resolve) => {
          img.onload = resolve;
          img.src = imgUrl;
        });
        // 背景图直接绘制，不应用滤镜
        tempCtx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height);
      }

      // 检测iOS设备
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isWechat = /MicroMessenger/i.test(navigator.userAgent);
      console.log('isIOS', isIOS, isWechat)
      // 绘制所有图片对象（只对前景图片应用滤镜）
      for (const imgObj of this.imagesData) {
        let imgElement;
        await new Promise((resolve) => {
          imgElement = new Image();
          imgElement.crossOrigin = 'anonymous';
          imgElement.onload = resolve;
          imgElement.src = this.imgHttps + imgObj.url;
        });
        
        const ratio = imgElement.width / imgElement.height;
        let drawWidth = imgObj.width * scale;
        let drawHeight = drawWidth / ratio;
        const drawX = (imgObj.x * scale) + ((imgObj.width * scale) - drawWidth) / 2;
        const drawY = (imgObj.y * scale) + ((imgObj.height * scale) - drawHeight) / 2;
        
        if (isIOS) {
          // iOS设备：手动应用所有滤镜效果
          const processedImage = await this.applyFiltersToImage(
            imgElement, 
            this.brightness,
            this.contrast,
            this.saturation,
            drawWidth,
            drawHeight
          );
          tempCtx.drawImage(processedImage, drawX, drawY);
        } else {
          // 其他设备：使用原生Canvas滤镜
          tempCtx.filter = `brightness(${this.brightness}%) contrast(${this.contrast}%) saturate(${this.saturation}%)`;
          tempCtx.drawImage(imgElement, drawX, drawY, drawWidth, drawHeight);
          tempCtx.filter = 'none';
        }
      }

      // 将临时 canvas 内容转换为图片的 Blob
      await new Promise(resolve => setTimeout(resolve, 1000));
      const blob = await new Promise((resolve) => {
          tempCanvas.toBlob(resolve, 'image/png', 1);
      });
      const file = new File([blob], `${new Date().getTime()}.png`, { type: 'image/png' });

      await this.getOSSKey();
      uploadImage(
        {
          file,
        },
        this.ossData
      ).then((res) => {
        let dataJsonHrss = {
          musicData: this.musicData,
          bgData: this.bgData,
          imagesData: this.imagesData,
          brightness: this.brightness || 100,
          contrast: this.contrast || 100,
          saturation: this.saturation || 100,
        }
        this.$ajax
          .post("/product/save", {
            id: this.id,
            // dataJson: JSON.stringify(saveData.jsonData),
            source: 1,
            name: this.name,
            // coverImage: res.addr,
            // useMaterials,
            describe: this.describe,
            dataJsonHrss: JSON.stringify(dataJsonHrss),
            effectImageHrss: res.addr
          })
          .then((lres) => {
            this.sucessTip = true;
          });
      });
      
      
    },
    applyFiltersToImage(img, brightnessValue, contrastValue, saturationValue, width, height) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        
        // 绘制原始图片
        ctx.drawImage(img, 0, 0, width, height);
        
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data;
        
        // 转换参数
        const brightness = brightnessValue / 100;
        const saturation = saturationValue / 100;
        
        // 对比度因子计算 (标准公式)
        const contrast = contrastValue;
        const contrastFactor = (259 * (contrast + 255)) / (255 * (259 - contrast));
        
        // 应用所有滤镜
        for (let i = 0; i < data.length; i += 4) {
          let r = data[i];
          let g = data[i + 1];
          let b = data[i + 2];
          
          // 1. 亮度调整
          r *= brightness;
          g *= brightness;
          b *= brightness;
          
          // 2. 对比度调整
          r = contrastFactor * (r - 128) + 128;
          g = contrastFactor * (g - 128) + 128;
          b = contrastFactor * (b - 128) + 128;
          
          // 3. 饱和度调整
          const gray = 0.2989 * r + 0.5870 * g + 0.1140 * b;
          r = gray + saturation * (r - gray);
          g = gray + saturation * (g - gray);
          b = gray + saturation * (b - gray);
          
          // 限制值范围并更新
          data[i] = Math.min(255, Math.max(0, r));
          data[i + 1] = Math.min(255, Math.max(0, g));
          data[i + 2] = Math.min(255, Math.max(0, b));
        }
        
        ctx.putImageData(imageData, 0, 0);
        
        const processedImg = new Image();
        processedImg.onload = () => resolve(processedImg);
        processedImg.src = canvas.toDataURL();
      });
    },
    back() {
      if (this.$router) {
        this.$router.go(-1);
      }
    },

    initAudio() {
      if (this.hasInteracted) return
      const audio = this.$refs.audio; 
      console.log('audio', audio)
      audio.play().catch(() => {}); // 首次尝试播放
      // 移除点击事件，避免重复触发
      this.$el.removeEventListener('click', this.initAudio);
      this.hasInteracted = true
    },
    // 添加新图片
    addImage(imgUrl, type, data) {
      const imageUrl = imgUrl
      
      const canvasRect = this.$refs.canvas.getBoundingClientRect();
      const canvasCenterX = canvasRect.width / 2;
      const canvasCenterY = canvasRect.height / 2;
      // console.log('data', data, data.id, this.imagesData.length)
      if (data && data.id) {
        this.imagesData.push(data);
        console.log('imagesData', this.imagesData)

        this.nextImageId = Math.max(...this.imagesData.map(img => img.id));
        this.maxZIndex = Math.max(...this.imagesData.map(img => img.zIndex));
      } else {
        if (this.imagesData.length == 0) {
          this.nextImageId = 1;
          this.maxZIndex = 1;
        } else {
          this.nextImageId = Math.max(...this.imagesData.map(img => img.id)) + 1 || 1;
          this.maxZIndex = Math.max(...this.imagesData.map(img => img.zIndex)) + 1 || 1;
        }
        this.imagesData.push({
          id: this.nextImageId,
          type: type || 1, // 图片类型，1为花 2为茶几
          url: imageUrl,
          x: canvasCenterX - 100, // 图片宽度的一半
          y: canvasCenterY - 150, // 图片高度的一半
          width: 200,
          height: 300,
          zIndex: this.maxZIndex
        });
      }
      
      this.selectedImageId = this.imagesData[this.imagesData.length - 1].id;
    },
    
    // 选择图片
    selectImage(id) {
      this.selectedImageId = id;
    },
    
    // 移除图片
    removeImageById(id) {
      this.imagesData = this.imagesData.filter(img => img.id !== id);
      if (this.selectedImageId === id) {
        this.selectedImageId = null;
      }
      
      // 更新最大 zIndex
      if (this.imagesData.length > 0) {
        this.maxZIndex = Math.max(...this.imagesData.map(img => img.zIndex));
      } else {
        this.maxZIndex = 1;
      }
    },
    
    // 改变层级
    changeLayer(action) {
      if (!this.selectedImage) return;
      
      const selectedImg = this.selectedImage;
      const currentIndex = selectedImg.zIndex;
      
      switch (action) {
        case 'top':
          selectedImg.zIndex = this.maxZIndex + 1;
          this.maxZIndex = selectedImg.zIndex;
          break;
          
        case 'up':
          if (currentIndex < this.maxZIndex) {
            selectedImg.zIndex++;
          }
          break;
          
        case 'down':
          if (currentIndex > 1) {
            selectedImg.zIndex--;
          }
          break;
          
        case 'bottom':
          // 将所有其他图片的zIndex加1
          this.imagesData.forEach(img => {
            if (img.id !== selectedImg.id) {
              img.zIndex++;
            }
          });
          selectedImg.zIndex = 1;
          this.maxZIndex++;
          break;
      }
    },
    setImageEffects(brightness, contrast, saturation) {
      this.brightness = brightness;
      this.contrast = contrast;
      this.saturation = saturation;
      this.updateImageEffects();
    },
    updateImageEffects() {
      const vm = this;
      this.imagesData.forEach((img, index) => {
        const newFilter = `brightness(${this.brightness}%) contrast(${this.contrast}%) saturate(${this.saturation}%)`;
        // 使用 Vue.set 确保响应式更新
        this.$set(this.imagesData, index, {
          ...img,
          filter: newFilter
        });
      });
    },
    // 图片鼠标按下事件
    handleImageMouseDown(img, e) {
      if (e.target.classList.contains('resize-handle')) return;
      
      this.isDragging = true;
      this.selectedImageId = img.id;
      
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.imageStartX = img.x;
      this.imageStartY = img.y;
      
      e.preventDefault();
      e.stopPropagation();
    },
    
    // 缩放控制点鼠标按下事件
    handleResizeMouseDown(img, e) {
      this.isResizing = true;
      this.selectedImageId = img.id;
      
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.imageStartWidth = img.width;
      this.imageStartHeight = img.height;
      this.aspectRatio = img.width / img.height;
      
      e.preventDefault();
    },
    
    // 画布鼠标按下事件
    handleCanvasMouseDown(e) {
      // 如果点击在空白区域，取消选中
      if (!e.target.closest('.image-container')) {
        this.selectedImageId = null;
      }
    },
    
    // 鼠标移动事件
    handleMouseMove(e) {
      if (!this.isDragging && !this.isResizing) return;
      
      const dx = e.clientX - this.dragStartX;
      const dy = e.clientY - this.dragStartY;
      
      if (this.isDragging && this.selectedImage) {
        this.selectedImage.x = this.imageStartX + dx;
        this.selectedImage.y = this.imageStartY + dy;
      }
      
      if (this.isResizing && this.selectedImage) {
        const newWidth = Math.max(50, this.imageStartWidth + dx);
        const newHeight = newWidth / this.aspectRatio;
        
        this.selectedImage.width = newWidth;
        this.selectedImage.height = newHeight;
      }
    },
    
    // 鼠标释放事件
    handleMouseUp() {
      this.isDragging = false;
      this.isResizing = false;
    },
    
    // 鼠标离开画布
    handleMouseLeave() {
      // console.log('handleMouseLeave')
      this.isDragging = false;
      this.isResizing = false;
    },
     // 画布触摸开始事件
     handleCanvasTouchStart(e) {
      e.stopPropagation();
      // console.log('handleCanvasTouchStart')
      const touch = e.touches[0];
      this.dragStartX = touch.clientX;
      this.dragStartY = touch.clientY;
      // console.log('handleCanvasTouchStart dragStartX, dragStartY', touch.clientX, touch.clientY)

      // 检查是否触摸到图片
      const target = e.target.closest('.image-container');
      if (target) {
        const imgId = parseInt(target.dataset.id); // 获取 data-id 属性值
        const img = this.imagesData.find(img => img.id === imgId);
        if (img) {
          if (e.target.classList.contains('resize-handle')) {
            this.isResizing = true;
            this.selectedImageId = img.id;
            this.imageStartWidth = img.width;
            this.imageStartHeight = img.height;
            this.aspectRatio = img.width / img.height;
          } else {
            this.isDragging = true;
            this.selectedImageId = img.id;
            this.imageStartX = img.x;
            this.imageStartY = img.y;
          }
        }
      } else {
        this.handleCanvasMouseDown(e);
      }
    },
    // 画布触摸移动事件
    handleCanvasTouchMove(e) {
      // console.log('handleCanvasTouchMove')
      const touch = e.touches[0];
      const newEvent = {
        clientX: touch.clientX,
        clientY: touch.clientY
      };
      // console.log('handleCanvasTouchMove clientX clientY', touch.clientX, touch.clientY)
      this.handleMouseMove(newEvent);
    },
    // 画布触摸结束事件
    handleCanvasTouchEnd() {
      // console.log('handleCanvasTouchEnd')
      this.handleMouseUp();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  // box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  // overflow: hidden;
}

.canvas {
  flex: 1;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  // 允许触摸拖动
  // touch-action: pan-x pan-y; 
  touch-action: none; 

}
.suc-main {
  padding: rem(120) 0;
  text-align: center;
  color: #2F2F2F;
  span {
    font-size: rem(32);
    color: #007CD9;
  }
}
.image-container {
  position: absolute;
  cursor: move;
  transition: border-color 0.2s;
  user-select: auto; 
  border: 2px solid transparent; 
  pointer-events: auto; 
  touch-action: pan-x pan-y; 
  box-sizing: border-box; 
}

.image-container:hover {
  border: 2px solid rgba(33, 150, 243, 0.5);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  // 允许鼠标交互
  pointer-events: auto; 
}

.resize-handle {
  position: absolute;
  right: -8px;
  bottom: -8px;
  width: 16px;
  height: 16px;
  background-color: #2196F3;
  border-radius: 50%;
  cursor: nwse-resize;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.control-panel {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.toolbar-btn:hover {
  background-color: #0b7dda;
}

.toolbar-btn i {
  margin-right: 5px;
}

.delete-btn {
  background-color: #f44336;
}

.delete-btn:hover {
  background-color: #d32f2f;
}

.layer-controls {
  display: flex;
  gap: 10px;
}

.layer-btn {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f0f4f8;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.layer-btn:hover {
  background-color: #e3eaf3;
  border-color: #ccc;
}

.layer-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.image-list {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding: 10px 0;
}

.image-list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}

.image-list-item:hover {
  background-color: #f0f4f8;
}

.image-list-item.selected {
  border-color: #2196F3;
  background-color: #e3f2fd;
}

.thumbnail {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 5px;
}

/* 图标样式 */
.icon-add::before {
  content: "+";
  font-weight: bold;
}

.icon-top::before {
  content: "↑↑";
}

.icon-up::before {
  content: "↑";
}

.icon-down::before {
  content: "↓";
}

.icon-bottom::before {
  content: "↓↓";
}

.icon-delete::before {
  content: "×";
  font-weight: bold;
}
.delete-button {
  position: absolute;
  left: -8px;
  top: -8px;
  width: 16px;
  height: 16px;
  background-color: #f44336;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
</style>

